import { IPhoto } from '../../models/Photos'
import initialState from './initialState'

export default function(
  store: IPhotosStore = initialState,
  action: any,
): IPhotosStore {
  switch (action.type) {
    case 'room photos accepted':
      return {
        ...store,
        loading: false,
        photos: action.photos,
      }
    case 'Save room pictures':
      return {
        ...store,
        loading: true,
      }
    case 'sort room images':
      return {
        ...store,
        photos: [
          ...store.photos.map(p =>
            action.images.find(i => Number(i.id) === Number(p.id))
              ? action.images.find(i => Number(i.id) === Number(p.id))
              : p,
          ),
        ],
      }
    case 'remove room photo':
      return {
        ...store,
        photos: [
          ...store.photos.filter(
            p => Number(p.id) !== Number(action.picture.id),
          ),
        ],
      }
    default:
      return store
  }
}

export interface IPhotosStore {
  photos: IPhoto[]
  loading: boolean
}
